import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeastTypeService, FeastType } from '../../services/feast-type.service';

@Component({
  selector: 'app-feast-type',
  templateUrl: './feast-type.component.html',
  styleUrls: ['./feast-type.component.css']
})
export class FeastTypeComponent implements OnInit {
  public entities: FeastType[];
  public isLoading = false;

  constructor(
    public dialog: MatDialog,
    private feastTypeSvc: FeastTypeService
  ) { }

  ngOnInit() {
    this.loadFeastTypes();
  }

  private loadFeastTypes() {
    console.log("LOADING FEAST TYPES");
    this.isLoading = true;

      this.feastTypeSvc.loadEntites().then(
        (data) => {
          this.entities = data;
          console.log("FeastTypes:", this.entities);

          this.isLoading = false;
        }
      ).catch((err) => {
        alert("Error while getting the FeastTypes"); //TODO this is temp
        console.log(err);

        this.isLoading = false;
      });

  }
 
  public edit(entity) {
    console.log(entity);
   // const dialogRef = this.dialog.open(E, {
      //data: serviceDate,
  //  });
  }
 

}
